/* eslint-disable */
import React, { useState } from 'react';
import { IconButton, Modal, Box, Typography, Divider, Button } from '@mui/material';
// import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CloseIcon from '@mui/icons-material/Close';

const HelpIcon = ({ title, ruleHelp, generalHelpDesc, generalHelp, sx }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const createMarkup = (htmlContent) => {
        try {
            return { __html: htmlContent };
        } catch (e) {
            // console.log(e);
        }
    };

    return (
        <>
            <IconButton onClick={handleOpen} style={{ cursor: 'help', marginLeft: '4px' }} sx={{ ...sx }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path
                        d="M8.11328 11.875H9.69662V7.125H8.11328V11.875ZM8.90495 5.54167C9.12925 5.54167 9.31741 5.46567 9.46941 5.31367C9.62141 5.16167 9.69714 4.97378 9.69662 4.75C9.69609 4.52622 9.62009 4.33833 9.46861 4.18633C9.31714 4.03433 9.12925 3.95833 8.90495 3.95833C8.68064 3.95833 8.49275 4.03433 8.34128 4.18633C8.18981 4.33833 8.11381 4.52622 8.11328 4.75C8.11275 4.97378 8.18875 5.16193 8.34128 5.31446C8.49381 5.46699 8.6817 5.54272 8.90495 5.54167ZM8.90495 15.8333C7.80981 15.8333 6.78064 15.6254 5.81745 15.2095C4.85425 14.7936 4.01641 14.2297 3.30391 13.5177C2.59141 12.8057 2.02748 11.9679 1.61212 11.0042C1.19675 10.0404 0.98881 9.01128 0.988282 7.91667C0.987754 6.82206 1.1957 5.79289 1.61212 4.82917C2.02853 3.86544 2.59246 3.0276 3.30391 2.31563C4.01535 1.60365 4.8532 1.03972 5.81745 0.623833C6.7817 0.207945 7.81086 0 8.90495 0C9.99903 0 11.0282 0.207945 11.9924 0.623833C12.9567 1.03972 13.7945 1.60365 14.506 2.31563C15.2174 3.0276 15.7816 3.86544 16.1986 4.82917C16.6155 5.79289 16.8232 6.82206 16.8216 7.91667C16.82 9.01128 16.6121 10.0404 16.1978 11.0042C15.7835 11.9679 15.2195 12.8057 14.506 13.5177C13.7924 14.2297 12.9546 14.7939 11.9924 15.2103C11.0303 15.6267 10.0011 15.8344 8.90495 15.8333ZM8.90495 14.25C10.673 14.25 12.1706 13.6365 13.3977 12.4094C14.6247 11.1823 15.2383 9.68472 15.2383 7.91667C15.2383 6.14861 14.6247 4.65104 13.3977 3.42396C12.1706 2.19687 10.673 1.58333 8.90495 1.58333C7.13689 1.58333 5.63932 2.19687 4.41224 3.42396C3.18516 4.65104 2.57162 6.14861 2.57162 7.91667C2.57162 9.68472 3.18516 11.1823 4.41224 12.4094C5.63932 13.6365 7.13689 14.25 8.90495 14.25Z"
                        fill="#BFBCBC"
                    />
                </svg>
            </IconButton>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-title" aria-describedby="modal-description">
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '50%',
                        bgcolor: 'background.paper',
                        border: '1px solid #ccc',
                        boxShadow: 24,
                        p: 2,
                        borderRadius: '8px',
                        outline: 'none',
                        maxHeight: '80vh',
                        overflow: 'auto'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 2
                        }}
                    >
                        {title && (
                            <Typography variant="h3" id="modal-title">
                                {title}
                            </Typography>
                        )}
                        <IconButton aria-label="close" onClick={handleClose} sx={{ color: 'grey.500' }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Divider />
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                            Rule Help:
                        </Typography>
                        {ruleHelp && (
                            <ul>
                                {ruleHelp.map((item, index) => (
                                    <li key={index}>
                                        <Typography variant="body2" dangerouslySetInnerHTML={createMarkup(item)} />
                                    </li>
                                ))}
                            </ul>
                        )}
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    <Box>
                        {(generalHelpDesc || generalHelp) && (
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                General Field Help:
                            </Typography>
                        )}
                        {generalHelpDesc && <Typography variant="body1" dangerouslySetInnerHTML={createMarkup(generalHelpDesc)} />}
                        {generalHelp && (
                            <ul>
                                {generalHelp.map((item, index) => (
                                    <li key={index}>
                                        <Typography variant="body2" dangerouslySetInnerHTML={createMarkup(item)} />
                                    </li>
                                ))}
                            </ul>
                        )}
                    </Box>
                    <Button variant="contained" color="primary" onClick={handleClose} startIcon={<CloseIcon />} sx={{ mt: 4 }}>
                        Close
                    </Button>
                </Box>
            </Modal>
        </>
    );
};

export default HelpIcon;
